import {Component, QueryList, ViewChildren} from '@angular/core';
import {KpiService} from "../../services/KpiService";
import {AuthService} from "../../services/AuthService";
import {apiconfig} from "../../app/api.config";
import {OperationService} from "../../services/OperationService";
import {
  AreaQuotaHourConsumptionReport,
  CustomerOrderHourlyQuotaTransfer,
  CustomerSectorHourQuotaReport,
  OperationHourConsumptionReport,
  TransferableCustomerOrderQuota,
  TransferableHourQuotaReport
} from "../../model/CustomerSectorHourQuotaReport";
import {OperationCard} from "../../model/OperationCard";
import {AlertController, NavParams} from "ionic-angular";
import {HomeKpi} from "../../model/HomeKpi";
import {LocupaChartsServiceProvider} from "../../providers/locupa-charts-service/locupa-charts-service";
import {LogaProxy} from "../../model/LogaProxy";


export class SelectItem {
  label: string;
  value: number;
}

export class TransfertQuotaDataContainer {
  srcOperationId: number;
  destOperationId: number;

  srcOptions: TransferableCustomerOrderQuota[] = [];
  destOptions: TransferableCustomerOrderQuota[] = [];

  transferableQuotaReport: TransferableHourQuotaReport;

  operations: SelectItem[] = [];

  srcCustomerOrderQuota: number;
  destCustomerOrderQuota: number;
  uiReAllocateQuotaQty: number = 0;

  public updateOptions() {
    this.srcOptions = [];
    this.destOptions = [];


    if (this.transferableQuotaReport != null)
      this.transferableQuotaReport.lines.forEach(opW => {

          let foundOp = false;

          for (let o of this.operations) {
            if (o.value == opW.operation.id) {
              foundOp = true;
              break;
            }
          }

          if (!foundOp) {
            let itm = new SelectItem();
            itm.label = opW.operation.name;
            itm.value = opW.operation.id;
            this.operations.push(itm);
          }

          if (this.srcOperationId != null && this.srcOperationId == opW.operation.id) {
            opW.quota.forEach(q => this.srcOptions.push(q));
          }

          if (this.destOperationId != null && this.destOperationId == opW.operation.id) {
            opW.quota.forEach(q => this.destOptions.push(q));
          }
        }
      );
  }

}

/**
 * Generated class for the QuotaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-quota',
  templateUrl: 'quota.html',
})
export class QuotaPage {
  QuotaPage

  @ViewChildren('chartCanvas') charts: QueryList<any>;

  /**
   * simple flag to dislpay spinning / waiting wheel
   */
  uiloading: boolean = false;


  apiConfig: any = apiconfig;

  private uiToggleSecondayMenuBar: boolean;
  private uiToggleDisplayAsDays: boolean;
  private uiToggleReallocateQuotaMode: boolean;

  private focusedOperation: OperationCard;
  private uiOperationReport: CustomerSectorHourQuotaReport;
  private uiOperationCardsById: OperationCard[] = [];

  private opKpi: HomeKpi[];


  // we have a simple map of ifs for each KPI that have been rendered to prevent from excessive loops
  private kpiAlreadyRendered: boolean[] = [];


  // -- variable to manager Quota transfer ---
  /**
   * flag to tell if we are currently re-allocating quota
   */
  uiReAllocateQuotaToggle: boolean[] = [];

  // selected profile id
  uiReallocateQuotaProfileId: any;

  // selected sector as source / from
  uiReallocateQuotaSectorFromId: any;

  // selected sector as destinatinon/ to
  uiReallocateQuotaSectorToId: any;

  // max allowable quantity baed on from selection
  uiReAllocateQuotaMaxQty: number;

  // allocated quantity
  uiReAllocateQuotaQty: any;

  // cache for profiles available
  profilesForOperations: LogaProxy[];

  // cache for sectors available as source
  sourceSectors: SelectItem[];

  // cache for sectors available as destionation
  destSectors: SelectItem[];

  // warning when we can't proceed to quota re-allocation
  uiReAllocateWarnings: string[][] = [];

  // link to use to download a file
  private uiCurrentDownloadLink: string;

  // --
  transfertQuotaDataContainer: TransfertQuotaDataContainer;


  constructor(private kpiService: KpiService,
              private authService: AuthService,
              public navParams: NavParams,
              public alertCtrl: AlertController,
              private locupaChartsServiceProvider: LocupaChartsServiceProvider,
              private operationService: OperationService) {
  }

  ionViewDidEnter() {

    this.uiToggleReallocateQuotaMode = false;

    //for now we put this as default, as KRO is the only one using this; but clearly, it's no good
    this.uiToggleDisplayAsDays = false;


    this.focusedOperation = this.navParams.get('operationCard');

    this.uiOperationCardsById = [];
    this.uiloading = true;

    this.repaintKpiPage();
  }


  private repaintKpiPage() {
    this.kpiService.loadQuotaReport(this.focusedOperation == null ? null : this.focusedOperation.id).then(
      (report: CustomerSectorHourQuotaReport) => {

        console.log('LoadQuotaReport...')
        console.log(report);

        // let's sort operation cards, let's use the id to be sure we have always something stable
        if (report.operationReports != null)
          report.operationReports.sort((a, b) => {
            return a.operation.id - b.operation.id;
          });
        this.opKpi = [];

        this.uiOperationReport = report;
        if (this.focusedOperation != null) {
          console.log('we have one operation to focus on : ' + this.focusedOperation.name)
          this.uiOperationCardsById[this.focusedOperation.id] = this.focusedOperation;

          let filtered = [];

          report.operationReports.forEach(op => {
            if (op.operation.id == this.focusedOperation.id) {
              filtered.push(op);
            }
          })
          report.operationReports = filtered;
          this.buildGlobalOperationKnobChart();
          this.uiloading = false;

        } else {
          this.operationService.loadOperationCards().then((cards) => {
            cards.forEach(c => this.uiOperationCardsById[c.id] = c);
            this.buildGlobalOperationKnobChart();
            this.uiloading = false;
            console.log("Operation cards loaded, ready to display");
            console.log(cards);
          });
        }


        this.charts.changes.subscribe(() => this.charts.toArray().forEach(
          (item) => {
            let opIdAndKpiType: string = item.nativeElement.id.split('|');
            if (opIdAndKpiType.length === 2) {
              let kpiId = opIdAndKpiType[1];

              //skip this to prevent from flickering, we don't want to repaint this continuously
              if (this.kpiAlreadyRendered[kpiId]) return;

              this.opKpi.forEach(hkpi => {
                if (hkpi.id == kpiId) {
                  this.locupaChartsServiceProvider.buildHomeKpiChart(hkpi, item);
                  this.kpiAlreadyRendered[kpiId] = true;
                }
              });
            }
          }));
      }
    ).then(() => {
      // load transferable quota report

      this.operationService.loadTransferableHoursQuotaReport().then(rep => {
        this.transfertQuotaDataContainer = new TransfertQuotaDataContainer();
        this.transfertQuotaDataContainer.transferableQuotaReport = rep;
        this.transfertQuotaDataContainer.updateOptions();
      }).catch(err => {
        console.log('errror while loading transfert report');
        console.log(err);
      });

    });


  }

  private buildGlobalOperationKnobChart() {
    if (this.uiOperationReport != null && this.uiOperationReport.operationReports != null) {

      this.uiOperationReport.operationReports.forEach(opR => {

        console.log(opR);

        let isFieldTeam = this.authService.loggedUser.hierarchicalNature === 'FIELDTEAM';
        if (isFieldTeam) {

          if (opR.globalQuota == null || opR.globalQuota <= 0) return;

          let kpi = new HomeKpi();
          kpi.id = 'kpi_' + opR.operation.id;
          kpi.title = 'Rapport Global';
          kpi.homeKpiType = 'STACKBARQuota';
          kpi.xs = 6;
          kpi.sm = 6;
          kpi.md = 6;
          kpi.lg = 6;

          let delta = opR.globalQuota - opR.consumedQuota;

          if (delta >= 0) {
            kpi.colors = ["purple", "green"];
            kpi.labels = ['Planifié', 'Disponible'];
            kpi.values = [opR.consumedAndRealisedQuota + opR.consumedAndPlannedQuota, delta];
          } else {
            kpi.colors = ["purple", "red"];
            kpi.labels = ['Planifié', 'Dépassement'];
            kpi.values = [opR.globalQuota, -delta];
          }

          this.opKpi.push(kpi);
        }

        if (this.authService.loggedUser.hierarchicalNature != null && opR.globalReportLine != null) {

          let gLine = opR.globalReportLine;

          let kpi = new HomeKpi();
          kpi.id = 'kpi_g_' + opR.operation.id;
          kpi.title = 'Synthèse Imputation Secteurs';
          kpi.homeKpiType = 'STACKBARQuota';
          kpi.xs = 12;
          kpi.sm = 12;
          kpi.md = isFieldTeam ? 6 : 12;
          kpi.lg = isFieldTeam ? 6 : 12;

          kpi.colors = ["purple", "lightblue", "green"];
          kpi.labels = ['Réalisé', 'Planifié', 'Restant'];
          kpi.values = [gLine.consumedAndRealisedQuota, gLine.consumedAndPlannedQuota, gLine.availableQuota];
          this.opKpi.push(kpi);
        }


      });
    }
  }


  asDys(a: number):
    number {
    return Math.round(a / 7);
  }

  /**
   * if true, then
   */
  displayGlobalReportLine(opReport: OperationHourConsumptionReport): boolean {
    //check if null or not defined
    if (opReport == null || opReport.globalReportLine == null) return false;
    //check if there is more than 1 areas, if one only, makes no sense to show global
    if (opReport.areas != null && opReport.areas.length == 1) return false;
    return true;
  }

  /**
   *
   * @param areaReport
   * @param b
   */
  reallocateQuota(areaReport: AreaQuotaHourConsumptionReport, b: boolean) {
    if (b) {
      // reset to neutral -- nothing selected
      // useful if another area was chosen
      this.profilesForOperations = this.findProfilesForOperation(areaReport);
      this.uiReallocateQuotaProfileId = null;
      this.uiReallocateQuotaSectorFromId = null;
      this.uiReallocateQuotaSectorToId = null;
      this.uiReAllocateQuotaQty = 0;
      this.uiReAllocateQuotaMaxQty = 0;
      this.sourceSectors = [];
      this.destSectors = [];
    }

    this.uiReAllocateQuotaToggle[areaReport.area.id] = b;

  }


  /**
   * convenient method to extract the actives profiles for a given area.
   * nothing really smart but not suitable to do in the UI
   * @param area
   */
  findProfilesForOperation(area: AreaQuotaHourConsumptionReport):
    LogaProxy[] {

    console.log('findProfilesForOperation');
    if (area == null) return [];
    if (area.sectors == null || area.sectors.length == 0) return [];

    const r: LogaProxy[] = [];
    area.sectors[0].operationProfiles.forEach(op => r.push(op.operationProfile));
    return r;
  }

  /**
   * convenient method to find out sources for sectors
   * @param area
   */
  findSourceSectors(area: AreaQuotaHourConsumptionReport): SelectItem[] {
    console.log('findSourceSectors');
    const sectors: SelectItem[] = [];
    area.sectors.forEach(sect => {
      sect.operationProfiles.forEach(prof => {
        if (prof.operationProfile.id == this.uiReallocateQuotaProfileId) {
          if (prof.availableQuota > 0) {
            const i = new SelectItem();
            i.label = sect.customerSector.name + " (disponible : " + prof.availableQuota + 'h )';
            i.value = sect.customerSector.id;
            sectors.push(i);
          }
        }
      });
    })
    return sectors;
  }

  /**
   * find the sectors we can select as destinations
   * @param area
   */
  findDestSectors(area: AreaQuotaHourConsumptionReport) {
    console.log('findDestSectors');
    const sectors: SelectItem[] = [];
    area.sectors.forEach(sect => {
      if (sect.customerSector.id == this.uiReallocateQuotaSectorFromId) {
        // this is the source sector, let's just find out what is the max allowed capacity to transfert
        sect.operationProfiles.forEach(prof => {
          if (prof.operationProfile.id == this.uiReallocateQuotaProfileId) {
            this.uiReAllocateQuotaMaxQty = prof.availableQuota;
          }
        });

      } else {
        // this is not a source sector, we can suggest it in the destinations
        sect.operationProfiles.forEach(prof => {
          if (prof.operationProfile.id == this.uiReallocateQuotaProfileId) {
            const i = new SelectItem();
            i.label = sect.customerSector.name;
            i.value = sect.customerSector.id;
            sectors.push(i);
          }
        });
      }
    })
    return sectors;
  }

  /**
   * reprocess selectors
   * @param area
   */
  reprocessReallocateQuota(area: AreaQuotaHourConsumptionReport) {

    if (this.uiReallocateQuotaProfileId == null)
      this.profilesForOperations = this.findProfilesForOperation(area);

    if (this.uiReallocateQuotaSectorFromId == null)
      this.sourceSectors = this.findSourceSectors(area);

    if (this.uiReallocateQuotaSectorToId == null)
      this.destSectors = this.findDestSectors(area);
  }

  /**
   * submit request
   */
  submitReAllocateRequest(areaQuotaConsumptionReport: AreaQuotaHourConsumptionReport, operationId: number) {

    this.uiReAllocateWarnings[areaQuotaConsumptionReport.area.id] = [];

    this.operationService.submitQuotaTransfer(operationId, this.uiReallocateQuotaProfileId, this.uiReallocateQuotaSectorFromId, this.uiReallocateQuotaSectorToId, this.uiReAllocateQuotaQty)
      .then(actionDone => {
        this.uiloading = true;

        if (actionDone.success) {
          this.uiOperationCardsById = [];
          this.kpiAlreadyRendered = [];
          this.uiReAllocateQuotaToggle = [];
          this.uiToggleReallocateQuotaMode = false;
          this.repaintKpiPage();

        } else {
          this.uiloading = false;
          this.uiReAllocateWarnings[areaQuotaConsumptionReport.area.id] = actionDone.warnings;
        }

      }).catch(err => {
      console.log('Error during quota submit');
      console.log(err);

      let alert = this.alertCtrl.create({
        title: 'Erreur Technique - Transfert impossible',
        message: 'Erreur technique, veuillez contacter votre interlocuteur agence',
        buttons: ['Fermer'],
        cssClass: 'alertDanger'
      });

      return alert.present();
    });


  }

  transfertQuota(): void {
    let req = new CustomerOrderHourlyQuotaTransfer();
    req.destCustomerOrderQuota = this.transfertQuotaDataContainer.destCustomerOrderQuota;
    req.sourceCustomerOrderQuota = this.transfertQuotaDataContainer.srcCustomerOrderQuota;
    req.transferAmount = this.transfertQuotaDataContainer.uiReAllocateQuotaQty;

    this.operationService.transfertQuota(req).then(result => {

      if (result.success) {
        let alert = this.alertCtrl.create({
          title: 'Transfert effectué',
          message: 'Votre de demande de transfert a été prise en compte',
          buttons: [{
            text: 'Retour', role: 'back', handler: () => {
              this.uiToggleReallocateQuotaMode = false;
              this.repaintKpiPage();
            }
          }]
        });
        return alert.present();

      } else {

        let str = '';
        if (result.warnings != null && result.warnings.length > 0) {
          result.warnings.forEach(s => str += s + ",");
          str = str.substring(0, str.length - 1);
        }

        let alert = this.alertCtrl.create({
          title: 'Erreur - Transfert impossible',
          message: str,
          buttons: ['Fermer'],
          cssClass: 'alertDanger'
        });
        return alert.present();
      }

    }).catch(err => {
      let alert = this.alertCtrl.create({
        title: 'Erreur Technique - Transfert impossible',
        message: 'Erreur technique, veuillez contacter votre interlocuteur',
        buttons: ['Fermer'],
        cssClass: 'alertDanger'
      });
      return alert.present();
    });
  }

  /**
   *
   * @param id
   */
  downloadQuotaExtract(id: number) {
    this.kpiService.loadXlsQuotaReport(id).then(uuid => {
      this.uiCurrentDownloadLink = uuid;
      console.log(uuid);
    });
  }


}



// WEBPACK FOOTER //
// ./src/pages/quota/quota.ts